module.exports = "https://www.gc-pro.gnp.com.mx/b811cfc9bb40138a3594cf58810112d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-mail-send.png
// module id = 8127
// module chunks = 0